export default __webpack_public_path__ + "assets/webgl/texture2.fea28bff.jpg";